import { useState, useEffect } from "react";
import {
  Frame,
  Loading,
  Header,
  Input,
  Switch,
  ValidaUid,
} from "../components";
import { db, storage } from "../config/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  setDoc,
  orderBy,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { Button, Col, Modal, Table } from "react-bootstrap";
import RangeSlider from "react-bootstrap-range-slider";
import { MoedaBr } from "../components/Formatar";
import { ValidaFinanceiro } from "../components/Validacao";

const Financeiro = () => {
  const [usuario, setUsuario] = useState({});
  const [financeiro, setFinanceiro] = useState({});
  const [vales, setVales] = useState(0);
  const [ferias, setFerias] = useState(false);
  const [erro, setErro] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(true);

  const params = new URLSearchParams(window.location.search);
  const competencia = params.get("competencia");

  const navigate = useNavigate();

  const buscaUsuario = async (uid) => {
    const qry = await getDoc(doc(db, "ebserh2026", uid));

    return new Promise((resolve) => {
      const data = qry.data();

      if (data?.anoAtual === "2026" && data?.status === "a") resolve(data);
      else resolve(0);
    });
  };

  const buscaFinanceiro = async () => {
    const qry = await getDocs(
      query(
        collection(db, "financeiro"),
        where("sistema", "==", "ebserh2026"),
        where("competencia", "==", competencia),
        where("ativo", "==", "1"),
        orderBy("dataDesconto", "asc")
      )
    );

    let docs = [];

    qry.forEach((doc) => {
      docs.push(doc.data());
    });

    return new Promise((resolve) => {
      resolve(docs[0]);
    });
  };

  const uploadArquivo = async (file, docPath, docUrl) => {
    if (!file) return;

    setLoading(true);

    const path = ref(storage, `ebserh2025/${usuario.uid}/${docPath}`);

    const upload = uploadBytesResumable(path, file, file.type);

    upload.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(upload.snapshot.ref).then((url) => {
          setUsuario({
            ...usuario,
            [docUrl]: url,
            [docPath]: "Enviado",
          });
          setLoading(false);
        });
      }
    );
  };

  const handleSwitch = () => {
    setFerias(!ferias);
    setVales(financeiro.quantidadeCredito);
  };

  const enviaDados = () => {
    const validar = ValidaFinanceiro(usuario, ferias, competencia);

    if (validar) setErro(validar);
    else gravaDados();
  };

  const gravaDados = async () => {
    setLoading(true);
    await setDoc(doc(db, "ebserh2026", usuario.uid), {
      ...usuario,
      ["vales" + competencia]: vales,
    });

    setLoading(false);
    setModalShow(true);
  };

  const fechaModal = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    const buscaDados = async () => {
      let uid = await ValidaUid();

      if (uid) {
        const u = await buscaUsuario(uid);

        const f = await buscaFinanceiro();

        if (u) {
          setUsuario(u);
          setFinanceiro(f);
          setVales(f?.quantidadeCredito);

          setLoading(false);
        } else {
          navigate("/home");
        }
      } else {
        navigate("/login");
      }
    };

    buscaDados();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={usuario?.nome} foto={usuario?.urlFoto} />

      {financeiro ? (
        <Frame
          body={
            <div className="p-2 text-start">
              <Table
                bordered
                hover
                size="sm"
                className="small my-4 text-center"
              >
                <thead className="align-middle">
                  <tr>
                    <th>Mensalidade</th>
                    <th>Qtde Mínima</th>
                    <th>Valor Vale</th>
                    <th>Valor Total</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className="align-middle">
                  {usuario["vales" + competencia] ? (
                    <tr>
                      <td>{financeiro.descricao}</td>
                      <td>{usuario["vales" + competencia]}</td>
                      <td>{MoedaBr(financeiro.valorCredito)}</td>
                      <td>
                        {MoedaBr(
                          usuario["vales" + competencia] *
                            financeiro.valorCredito
                        )}
                      </td>

                      <td>{usuario?.["pagto" + competencia] || "Não Pago"}</td>
                    </tr>
                  ) : (
                    <tr>
                      <td>{financeiro.descricao}</td>
                      <td>{financeiro.quantidadeCredito}</td>
                      <td>{MoedaBr(financeiro.valorCredito)}</td>
                      <td>{MoedaBr(financeiro.valorMesNormal)}</td>

                      <td>{usuario?.["pagto" + competencia] || "Não Pago"}</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {usuario["pagto" + competencia] === "Pago" ? (
                <div className="my-4 h6 text-center">
                  <p>Pagamento recebido.</p>
                  <p>Obrigado por utilizar nossos serviços.</p>
                </div>
              ) : (
                <>
                  <div className="my-4">
                    <i>
                      Para pagar sua mensalidade, selecione a quantidade de
                      vales e faça um pix para a chave abaixo. Caso tenha
                      desconto de férias, envie o comprovante de férias para
                      selecionar uma quantidade menor que o mínimo.
                    </i>
                  </div>

                  <div className="my-4">
                    <RangeSlider
                      value={vales}
                      onChange={(e) => setVales(e.target.value)}
                      min={ferias ? 1 : financeiro.quantidadeCredito}
                      max={60}
                    />
                  </div>

                  <div className="my-4 text-center">
                    <h5>{`Vales: ${vales}`}</h5>
                    <h5>{`Valor: ${MoedaBr(
                      vales * financeiro.valorCredito
                    )}`}</h5>
                    <h5>Chave Pix CNPJ:</h5>
                    <h5>92.189.612/0001-92</h5>
                  </div>

                  <div className="my-4">
                    <Input
                      id={"urlPagto" + competencia}
                      label={financeiro.descricao}
                      type="file"
                      url={usuario?.["urlPagto" + competencia]}
                      className={erro.pagto && "is-invalid"}
                      erro={erro.pagto}
                      accept=".jpg, .jpeg, .png, .pdf"
                      onChange={(e) =>
                        uploadArquivo(
                          e.target.files[0],
                          "pagto" + competencia,
                          "urlPagto" + competencia
                        )
                      }
                    />
                  </div>

                  <div className="text-start my-4">
                    <Switch
                      label="Estarei de férias nesse mês"
                      id="ferias"
                      checked={ferias}
                      onChange={handleSwitch}
                    />
                  </div>

                  {ferias && (
                    <div className="my-4">
                      <Input
                        id={"urlFerias" + competencia}
                        disabled={!ferias}
                        label={"Comprovante de Férias"}
                        type="file"
                        className={erro.ferias && "is-invalid"}
                        erro={erro.ferias}
                        accept=".jpg, .jpeg, .png, .pdf"
                        onChange={(e) =>
                          uploadArquivo(
                            e.target.files[0],
                            "ferias" + competencia,
                            "urlFerias" + competencia
                          )
                        }
                        url={usuario["urlFerias" + competencia]}
                      />
                    </div>
                  )}

                  <div className="my-4">
                    <Col className="d-grid">
                      <Button onClick={enviaDados}>Enviar</Button>
                    </Col>
                  </div>
                </>
              )}
            </div>
          }
          title="Financeiro"
        />
      ) : (
        <Frame
          body={
            <div className="my-4 p-2 text-start">
              Mensalidade ainda não liberada para pagamento. Por gentileza,
              tente novamente mais tarde.
            </div>
          }
          title="Financeiro"
        />
      )}

      <Modal show={modalShow} onHide={fechaModal}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Comprovante enviado com sucesso!</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={fechaModal}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Financeiro;
